import React, { useState, useEffect } from "react";
import HomeHeader from "./HomeHeader";
import About from "./About";
import HomeSlide from "./HomeSlide";
import AdmissionSession from "./AdmissionSession";
import Card from "./Card";
import CardForCourseGuide from "./CardForCourseGuide";
import Footer from "./Footer";
import api from "../api/api";
import TotalStudentAndApplySection from "./TotalStudentAndApplySection";



import "./Styles/home.css";

const Home = () => {


  return (
    <div>
      <div className="headerderty">
        <HomeHeader />
      </div>

 

  <Card />
      {/* <CardForCourseGuide /> */}



      <div className="homeeeSlide">
        <About />
      </div>





      <Footer />
    </div>
  );
};

export default Home;
